import fecha from 'fecha';

import locales from './locales';
import getCurrentLanguageKey from '../getCurrentLanguageKey';

import { CUSTOM_FORMAT } from './constants';

const toString = (date: Date, fmt?: string, lang?: 'es' | 'pt') => {
  fecha.i18n = locales[lang || getCurrentLanguageKey()];
  const d = fecha.format(date, fmt || CUSTOM_FORMAT);

  return d
    .charAt(0)
    .toUpperCase()
    .concat(d.slice(1));
};

export default toString;
